import type { HTMLAttributes } from 'react';

import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faMagicWandSparkles } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ClassValue } from 'clsx';

import { cn } from '../../lib/utils';

export interface AiOrbProps {
    className?: ClassValue;
    dataTestid?: string;
    htmlAttributes?: HTMLAttributes<HTMLDivElement>;
    icon?: IconDefinition;
    size?: 'small' | 'medium' | 'large';
    animated?: boolean;
}

const ORB_SIZE_CLASSES: Record<NonNullable<AiOrbProps['size']>, string> = {
    small: 'size-10',
    medium: 'size-16',
    large: 'size-20',
};

const ICON_SIZE_CLASSES: Record<NonNullable<AiOrbProps['size']>, string> = {
    small: 'text-base',
    medium: 'text-2xl',
    large: 'text-3xl',
};

export const AiOrb = ({
    className,
    dataTestid = 'AiOrb',
    htmlAttributes,
    icon = faMagicWandSparkles,
    size = 'medium',
    animated = true,
}: AiOrbProps) => (
    <div
        className={cn(
            'flex items-center justify-center rounded-full border border-lime-400 bg-[radial-gradient(circle_at_40%_30%,#18230d,#12190b_54%,#0a0f08_100%)] shadow-[0_0_0_6px_rgba(132,204,22,0.16),0_14px_30px_rgba(0,0,0,0.28)]',
            ORB_SIZE_CLASSES[size],
            animated && 'animate-ai-pulse',
            className
        )}
        data-testid={dataTestid}
        data-component-name='AiOrb'
        {...htmlAttributes}
    >
        <FontAwesomeIcon
            icon={icon}
            className={cn(ICON_SIZE_CLASSES[size], 'text-lime-400')}
        />
    </div>
);
